import { useAsync, UseAsyncReturn } from 'react-async-hook';
import { useApi } from 'hooks/useApi';

export type UseGetResult<T> = UseAsyncReturn<T | null, unknown[]>;

export const useGet = <T>(url: string, dependencies: unknown[] = []) => {
  const api = useApi();

  return useAsync(() => api.get<T>(url), dependencies);
};
